import { __extends } from "tslib";
import { FilterUtils } from '../../../utils/FilterUtils';
import { TaskBaseWebGL } from './TaskBaseWebgGL';
var VERTEX = "\nprecision highp float;\nuniform vec4 uTexMatrix[2];\nuniform vec4 uTexMatrixSource;\n\n/* AGAL legacy atrib resolver require this names */\nattribute vec4 va0; // position\n\nvarying vec2 vUv[2];\n\nvoid main() {\n\tvec4 pos = va0;\n\n\tpos.xy = pos.xy * uTexMatrix[0].zw + uTexMatrix[0].xy;\n\tpos.z = pos.z * 2.0 - pos.w;\n\n    gl_Position = pos;\n\n\tvUv[0] = clamp((va0.xy * uTexMatrix[1].zw) + uTexMatrix[1].xy, 0., 1.);\n\tvUv[1] = clamp((va0.xy * uTexMatrixSource.zw) + uTexMatrixSource.xy , 0., 1.);\n}\n\n";
var FRAG = "\nprecision highp float;\n\nuniform vec4 uHColor;\nuniform vec4 uSColor;\nuniform float uStrength;\nuniform vec3 uType;\nuniform vec2 uDir;\n\nvarying vec2 vUv[2];\n\n/* AGAL legacy attrib resolver require this names */\n// blur\nuniform sampler2D fs0;\n\n/* AGAL legacy attrib resolver require this names */\n// source\nuniform sampler2D fs1;\n\nvoid main() {\n\tvec4 color = texture2D(fs1, vUv[1]);\n\t\n\tfloat a = color.a;\n\n\t// LOOL.. there are a bug - we PMA it twice, devide to compense\n\tif (a > 0.) color.a /= a;\n\n\tfloat high = texture2D(fs0, vUv[0] - uDir).a;\n\tfloat shadow = texture2D(fs0, vUv[0] + uDir).a;\n\tfloat factor = high - shadow;\n\n\tshadow = min(1., max(0., factor) * uStrength) * uSColor.a;\n\thigh = min(1., max(0., -factor) * uStrength) * uHColor.a;\n\n\tfloat cut = color.a * uType[1] + (1.0 - color.a) * uType[2];\n\tvec4 outColor = vec4(\n\t\tuSColor.rgb * shadow + uHColor.rgb * high,\n\t\tshadow + high\n\t) * cut;\n\n\tgl_FragColor = color * (1. - outColor.a) * uType[0] + outColor;\n\tgl_FragColor *= a;\n}";
var BevelTask = /** @class */ (function (_super) {
    __extends(BevelTask, _super);
    function BevelTask() {
        var _this = _super.call(this) || this;
        _this.activateInternaly = false;
        _this._uSColor = new Float32Array([0, 0, 0, 1]);
        _this._uHColor = new Float32Array([1, 1, 1, 1]);
        _this._shadowInvalid = false;
        _this._shadowColor = 0x0;
        _this._shadowAlpha = 1;
        _this._highlightInvalid = false;
        _this._highlightColor = 0xfffff;
        _this._highlightAlpha = 1;
        _this._dirInvalid = false;
        _this._angle = 45;
        _this._distance = 4;
        _this.strength = 1;
        _this.knockout = false;
        _this.type = 'inner';
        _this._focusId = -1;
        return _this;
    }
    Object.defineProperty(BevelTask.prototype, "shadowColor", {
        get: function () {
            return this._shadowColor;
        },
        set: function (value) {
            if (this.shadowColor === value)
                return;
            this._shadowColor = value;
            this._shadowInvalid = true;
            FilterUtils.colorToArray(this._shadowColor, this._shadowAlpha, this._uSColor);
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(BevelTask.prototype, "shadowAlpha", {
        get: function () {
            return this._shadowAlpha;
        },
        set: function (value) {
            if (value === this._shadowAlpha)
                return;
            this._shadowAlpha = value;
            this._uSColor[3] = value;
            this._shadowInvalid = true;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(BevelTask.prototype, "highlightColor", {
        get: function () {
            return this._highlightColor;
        },
        set: function (value) {
            if (this._highlightColor !== value)
                return;
            this._highlightColor = value;
            FilterUtils.colorToArray(this._highlightColor, this._highlightAlpha, this._uHColor);
            this._highlightInvalid = true;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(BevelTask.prototype, "highlightAlpha", {
        get: function () {
            return this._highlightAlpha;
        },
        set: function (value) {
            if (this._highlightAlpha === value)
                return;
            this._highlightAlpha = value;
            this._uHColor[3] = value;
            this._highlightInvalid = true;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(BevelTask.prototype, "angle", {
        get: function () {
            return this._angle;
        },
        set: function (value) {
            if (value === this._angle)
                return;
            this._angle = value;
            this._dirInvalid = true;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(BevelTask.prototype, "distance", {
        get: function () {
            return this._distance;
        },
        set: function (value) {
            if (value === this._distance)
                return;
            this._distance = value;
            this._dirInvalid = true;
        },
        enumerable: false,
        configurable: true
    });
    BevelTask.prototype.getVertexCode = function () {
        return VERTEX;
    };
    BevelTask.prototype.getFragmentCode = function () {
        return FRAG;
    };
    BevelTask.prototype.activate = function (_stage, _projection, _depthTexture) {
        _super.prototype.computeVertexData.call(this);
        var tex = this._source;
        var prog = this._program3D;
        var needUpload = prog.focusId !== this._focusId;
        prog.uploadUniform('uTexMatrix', this._vertexConstantData);
        (needUpload || this._shadowInvalid) && prog.uploadUniform('uSColor', this._uSColor);
        (needUpload || this._highlightInvalid) && prog.uploadUniform('uHColor', this._uHColor);
        if (needUpload || this._dirInvalid) {
            var rad = this.angle * Math.PI / 180;
            prog.uploadUniform('uDir', [
                Math.cos(rad) * this.distance / tex.width,
                Math.sin(rad) * this.distance / tex.height
            ]);
        }
        prog.uploadUniform('uStrength', this.strength);
        prog.uploadUniform('uType', [
            this.knockout ? 0 : 1,
            this.type !== 'outer' ? 1 : 0,
            this.type !== 'inner' ? 1 : 0
        ]);
        prog.uploadUniform('uTexMatrixSource', [
            0, 0,
            this.inputRect.width / this.sourceImage.width,
            this.inputRect.height / this.sourceImage.height,
        ]);
        this.sourceImage.getAbstraction(_stage).activate(1);
        this._focusId = prog.focusId;
        this._shadowInvalid = this._highlightInvalid = this._dirInvalid = false;
    };
    return BevelTask;
}(TaskBaseWebGL));
export { BevelTask };
